// import React from "react";
// import { Link } from "react-router-dom";

// const Home = () => {
//   return (
//     <div>

//       {/* HERO SECTION */}
//       <section className="hero">
//         <div className="container">
//           <h1>Welcome to MyCompany</h1>
//           <p>
//             We help businesses grow through DGFT services,
//             Government Subsidies and Professional Consulting.
//           </p>

//           <Link to="/contact" className="btn">
//             Request Consultation
//           </Link>
//         </div>
//       </section>

//       {/* SERVICES SECTION */}
//       <section className="section">
//         <div className="container">

//           <h2 style={{textAlign:"center"}}>Our Services</h2>
//           <br/>

//           <div className="grid-3">

//             <div className="card">
//               <h3>DGFT Services</h3>
//               <p>
//                 IEC Registration, Export License and
//                 complete import-export consultancy.
//               </p>
//               <Link to="/dgft/iec" className="btn">Learn More</Link>
//             </div>

//             <div className="card">
//               <h3>Industrial Subsidy</h3>
//               <p>
//                 Central and State government subsidy
//                 approvals for industries.
//               </p>
//               <Link to="/subsidy/state" className="btn">Learn More</Link>
//             </div>

//             <div className="card">
//               <h3>Business Consulting</h3>
//               <p>
//                 Complete business compliance and
//                 strategic consulting solutions.
//               </p>
//               <Link to="/consulting" className="btn">Learn More</Link>
//             </div>

//           </div>

//         </div>
//       </section>

//     </div>
//   );
// };

// export default Home;


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Workflow from "../components/Workflow";
// import business from "../assets/shutterstock_1273165201.jpg";
import business from "../assets/c311c1c8-39c2-4c4f-a421-0bc5340b7698.jfif";
import dgfticon from "../assets/dgft-icon.png";
import industrialsubsidy from "../assets/subsidy-icon.png";

// import { FiFileText, FiDollarSign, FiHome, } from "react-icons/fi";

const Home = () => {

  const images = [
    require("../assets/home/main1.jpeg"),
    require("../assets/home/main2.jpeg"),
    require("../assets/home/main3.jpeg"),
    require("../assets/home/main6.jpeg"),
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
  const interval = setInterval(() => {
    setIndex((prev) => (prev + 1) % images.length);
  }, 5000);

  return () => clearInterval(interval);
  }, [images.length]);
  
  return (
    <div className="home-page">

      {/* HERO SECTION */}
      {/* <section className="hero-banner">
        <div className="hero-overlay">
          <div className="container hero-content">
            <h1>APEX Consultants</h1>
            <h2>Subsidy & DGFT Services</h2>
            <p>
              We provide expert consultancy services in DGFT licensing, Industrial Subsidies, Export-Import compliance and government incentive schemes. Our team assists businesses across India in navigating complex regulatory frameworks and maximizing eligible benefits for sustainable growth.
            </p>
            <Link to="/contact" className="btn">
              Get Started Now
            </Link>
          </div>
        </div>
      </section> */}

      <section
        className="hero-banner"
        style={{
          backgroundImage: `url(${images[index]})`,
        }}
      ></section>

      {/* ABOUT PREVIEW */}
      <section className="about-preview">
  <div className="container">
    <div className="about-card">

      <div className="about-accent"></div>

      <div className="about-content">
              <h2>About Us</h2>
              
              {/* <p>
          At APEX Consultants, we provide specialized consultancy services for DGFT Liaisoning (EXIM), Industrial Subsidies, and government incentive schemes. With more than 12 years of professional experience, we support businesses in securing approvals, licenses, and financial benefits from government programs. Our mission is to simplify regulatory procedures and help organizations focus on growth and expansion.
        </p> */}
          <p> At   Apex   consultancy we provide   expert   consultancy   service in DGFT   Liaising   (EXIM)  Industrial  Subsidies  and Government  Incentive  Schemes. To support   business   in navigating   government   procedures   smoothly   . Our goal is to simplify complex documentation and approval process for Entrepreneurs and organization.</p>
<p>With over 12 years of Experience, our team has successfully guided clients in DGFT licensing. Import – Export documentation reliable guidance, accurate documentation and timely support to ensure seamless approvals.</p>
<p>At Apex consultancy, we believe in building long term relationships with our clients by providing professional services, transparency and trusted consultancy that help businesses grow and explore new opportunities in domestic and international markets.</p>
        <Link to="/about" className="about-link">Read More</Link>
      </div>

    </div>
  </div>
</section>


      {/* WHY CHOOSE US */}
<section className="why-section">
  <div className="container why-grid">

    {/* LEFT IMAGE */}
    <div className="why-image">
      <img
        src={business}
        alt="business"
            />
            
             <div className="image-overlay">
    <div className="brand-text">
      <h3 className="brand-apex">APEX</h3>
      <h4 className="brand-consultants">CONSULTANTS</h4>
      <p className="brand-tagline">Subsidy & DGFT Services</p>
    </div>
  </div>
    </div>

    {/* RIGHT CONTENT */}
    <div className="why-content">

      <h2 className="why-title">Why Most People Choose Our Business Services</h2>

            <p className="why-desc">At Apex consultancy our strength lies in our 12  year of experience and deep  under standing of DGFT, Import – Export and NABARD consultancy services our team is committed to providing reliable guidance ,precise documentation and dedicated support to businesses at every stage of the process. </p>
            <p>We Focus on simplifying complex government procedures and ensuring smooth approvals for our clients with a strong commitment to professionalism, transparency and client success. Apex consultancy stands as a trusted partner for businesses looking to grow and explore new opportunities.</p>
            <p>Many people are unaware of the government schemes and subsidies available for agriculture and business projects. Our team helps clients understand these opportunities clearly and guides them through the entire process. From identifying the right scheme to preparing project reports and completing documentation. We provide step by step support. We focus on making the process simple, transparent and hassle – free. So that farmers, entrepreneurs and business owners can easily access the benefits they deserve.</p>

      {/* <p className="why-desc">Businesses today often face challenges in understanding complex government regulations, export–import policies, and industrial incentive schemes. Navigating these processes requires expertise, proper documentation, and efficient liaison with authorities.

              <br/>
        At APEX Consultants, we simplify these procedures and help businesses obtain approvals, licenses, and government benefits smoothly. With our professional experience and practical approach, we ensure faster processing, accurate compliance, and reliable consultancy support.
      </p> */}

      {/* FEATURES */}

  {/* <div className="why-features">

      <div className="why-item">
        <div className="why-icon"><FiFileText /></div>
        <div className="why-text">
                  <h3>DGFT Liaisoning (EXIM)</h3>
                  <p>Exporters and importers frequently face difficulties in obtaining DGFT licenses, approvals, and compliance clearances. Our team provides complete assistance in DGFT-related matters including license applications, amendments, compliance filings, and government liaisoning, ensuring smooth and efficient processing.</p>
                  <Link to="/dgft" className="read-more">Read More</Link>
          {/* <a href="/dgft">Read More</a> */}
        {/* </div>
      </div>

      <div className="why-item">
        <div className="why-icon"><FiDollarSign /></div>
        <div className="why-text">
          <h3>Industrial Subsidies</h3>
                  <p>Government subsidy schemes provide valuable financial support for industries, but the application and approval process can be complex. We assist businesses in identifying eligible subsidy schemes, preparing documentation, filing applications, and securing approvals, helping industries maximize available government incentives.</p>
                    <Link to="/industrial-subsidies" className="read-more">Read More</Link>
        </div>
      </div>

        <div className="why-item">
          <div className="why-icon"><FiHome /></div>
          <div className="why-text">
            <h3>MOOWR Scheme</h3>
            <p>The MOOWR (Manufacture and Other Operations in Warehouse Regulations) Scheme allows manufacturers to defer customs duties on imported goods used for manufacturing. Our consultancy services guide businesses through MOOWR registration, compliance procedures, and operational implementation, enabling companies to optimize costs and improve operational efficiency.</p>
            <Link to="/moowr" className="read-more">Read More</Link>
          </div>
        </div>
              
        </div> */} 


    </div>
          
  </div>
</section>

      <section className="services-section">
  <div className="container">
    <h2 className="section-title">Our Services</h2>
    <p className="section-subtitle">
      Comprehensive solutions to streamline your operations
    </p>

    <div className="services-grid">

      {/* Card 1 */}
      <div className="service-card">
        <img src={dgfticon} alt="DGFT" className="serviceicon" />
        <h3>DGFT Services</h3>
        <p>
          Expert assistance with DGFT documentation and compliance for smooth operations.
        </p>
        <a href="/dgft">Learn More →</a>
      </div>

      {/* Card 2 */}
      <div className="service-card">
        <img src={industrialsubsidy} alt="Subsidy" />
        <h3>Industrial Subsidies</h3>
        <p>
          Guidance on eligibility, documentation, and claim processes for subsidies.
        </p>
        <a href="/industrial-subsidies">Learn More →</a>
      </div>     

    </div>
  </div>
</section>


      {/* ICON FEATURES */}
      <section className="icon-section">
        <div className="container grid-4">

          <div className="icon-box">
            <h2>12+</h2>
            <p>Years Experience</p>
          </div>

          <div className="icon-box">
            <h2>Quality</h2>
            <p>Policy Driven Process</p>
          </div>

          <div className="icon-box">
            <h2>ISO</h2>
            <p>Certified Standards</p>
          </div>

          <div className="icon-box">
            <h2>Vision</h2>
            <p>Client First Approach</p>
          </div>

        </div>
      </section>

      {/* BLOG SECTION */}
      {/* <section className="section">
        <div className="container">
          <h2 style={{ textAlign: "center" }}>Our Blog</h2>
          <br />

          <div className="blog-banner">
            <Link to="/blog" className="btn">
              Click Here To View Blogs
            </Link>
          </div>
        </div>
      </section> */}

      {/* NOTIFICATIONS */}
      {/* <section className="section">
        <div className="container">
          <h2>Latest Notifications</h2>
          <br />

          <div className="grid-4">

            <div className="card">
              <h3>DGFT</h3>
              <p>Export policy updates and circulars.</p>
            </div>

            <div className="card">
              <h3>Industrial Subsidy</h3>
              <p>Latest subsidy scheme updates.</p>
            </div>

            <div className="card">
              <h3>Policy Updates</h3>
              <p>Regulation amendments & guidelines.</p>
            </div>

            <div className="card">
              <h3>Trade Alerts</h3>
              <p>Important notifications for exporters.</p>
            </div>

          </div>
        </div>
      </section> */}

          <Workflow />

          <section className="presence-section">
  <div className="container">
    
    <h2 className="section-title">Our Presence</h2>
    <p className="section-subtitle">
      We are serving clients across multiple locations in India
    </p>

    <div className="presence-grid">

      <div className="presence-card telangana">
        <h3>Telangana</h3>
        <p>Head Office</p>
      </div>

      <div className="presence-card ap">
        <h3>Andhra Pradesh</h3>
        <p>Service Area</p>
      </div>

      <div className="presence-card maharashtra">
        <h3>Maharashtra</h3>
        <p>Service Area</p>
      </div>

 <div className="presence-card karnataka">
        <h3>Karnataka</h3>
        <p>Service Area</p>
      </div>            
            

      <div className="presence-card mp">
        <h3>Madhya Pradesh</h3>
        <p>Service Area</p>
            </div>

            <div className="presence-card delhi">
        <h3>Delhi</h3>
        <p>Service Area</p>
      </div>

    </div>

  </div>
</section>


    </div>
  );
};

export default Home;


// import React from "react";
// import { Link } from "react-router-dom";
// // import "./home.css";

// const Home = () => {
//   return (
//     <div>

//       {/* HERO SECTION */}
//       <section className="hero-section">
//         <div className="hero-overlay">
//           <div className="container hero-content">
//             <h1>APEX Consultants</h1>
//             <h2>Subsidy & DGFT Services</h2>
//             <p>
//               We provide professional consultancy services for DGFT,
//               Industrial Subsidy and Business Compliance across India.
//             </p>

//             <Link to="/contact" className="primary-btn">
//               Get Free Consultation
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* ABOUT SECTION */}
//       <section className="about-section container">
//         <div className="about-left">
//           <img src="/logo192.png" alt="company logo" />
//         </div>

//         <div className="about-right">
//           <h2>About APEX Consultants</h2>
//           <p>
//             APEX Consultants provides complete DGFT Liaisoning (EXIM) and
//             Industrial Subsidy consultancy. With over 12 years of experience,
//             we help businesses obtain approvals, licenses and government benefits
//             smoothly without complications.
//           </p>

//           <ul>
//             <li>IEC Registration</li>
//             <li>Export & Import Licenses</li>
//             <li>Industrial Subsidy Approvals</li>
//             <li>Business Compliance Consulting</li>
//           </ul>
//         </div>
//       </section>

//       {/* SERVICES */}
//       <section className="services-section">
//         <div className="container">
//           <h2 className="section-title">Our Services</h2>

//           <div className="service-grid">

//             <div className="service-card">
//               <h3>DGFT Liaisoning (EXIM)</h3>
//               <p>IEC, Advance Authorization, EPCG, RCMC, MEIS, RoDTEP & More.</p>
//             </div>

//             <div className="service-card">
//               <h3>Industrial Subsidies</h3>
//               <p>Central & State Government subsidy approvals and documentation.</p>
//             </div>

//             <div className="service-card">
//               <h3>MOOWR Scheme</h3>
//               <p>Customs duty deferment benefits for manufacturers.</p>
//             </div>

//             <div className="service-card">
//               <h3>Business Consulting</h3>
//               <p>End-to-end compliance and regulatory support.</p>
//             </div>

//           </div>
//         </div>
//       </section>

//       {/* HOW WE WORK */}
//       <section className="workflow-section container">
//         <h2 className="section-title">How We Work</h2>

//         <div className="steps">

//           <div className="step">
//             <h3>Sales Team</h3>
//             <p>We collect requirements and assign a project lead.</p>
//           </div>

//           <div className="step">
//             <h3>Operations Team</h3>
//             <p>Documents verification and application preparation.</p>
//           </div>

//           <div className="step">
//             <h3>Statistics</h3>
//             <p>Indexing, numbering and record management.</p>
//           </div>

//           <div className="step">
//             <h3>Liaisoning</h3>
//             <p>Continuous follow-ups with departments until approval.</p>
//           </div>

//         </div>
//       </section>

//       {/* CONTACT STRIP */}
//       <section className="contact-strip">
//         <div className="container strip-content">
//           <div>
//             <h3>Veera Babu</h3>
//             <p>Sr. Consultant</p>
//           </div>

//           <div>
//             <p>📞 +91 72077 57511</p>
//             <p>✉ veera@apexconsultants.in</p>
//             <p>🌐 www.apexconsultants.in</p>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// };

// export default Home;


